import React from "react";

const Infinity = ({ className }: { className?: string }) => (
  <svg
    width="31"
    height="31"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <mask
      id="mask0_863_587"
      style={{maskType:'alpha'}}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="31"
      height="31"
    >
      <rect width="31" height="31" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_863_587)">
      <path
        d="M7.10417 22.6038C5.12361 22.6038 3.44444 21.915 2.06667 20.5372C0.688889 19.1594 0 17.4802 0 15.4997C0 13.5191 0.688889 11.84 2.06667 10.4622C3.44444 9.0844 5.12361 8.39551 7.10417 8.39551C7.90069 8.39551 8.66493 8.53544 9.39687 8.8153C10.1288 9.09516 10.7854 9.49342 11.3667 10.0101L13.5625 12.0122L11.625 13.7559L9.62292 11.9476C9.27847 11.6462 8.89097 11.4094 8.46042 11.2372C8.02986 11.065 7.57778 10.9788 7.10417 10.9788C5.85556 10.9788 4.78993 11.4202 3.90729 12.3028C3.02465 13.1854 2.58333 14.2511 2.58333 15.4997C2.58333 16.7483 3.02465 17.8139 3.90729 18.6965C4.78993 19.5792 5.85556 20.0205 7.10417 20.0205C7.57778 20.0205 8.02986 19.9344 8.46042 19.7622C8.89097 19.59 9.27847 19.3531 9.62292 19.0518L19.6333 10.0101C20.2146 9.49342 20.8712 9.09516 21.6031 8.8153C22.3351 8.53544 23.0993 8.39551 23.8958 8.39551C25.8764 8.39551 27.5556 9.0844 28.9333 10.4622C30.3111 11.84 31 13.5191 31 15.4997C31 17.4802 30.3111 19.1594 28.9333 20.5372C27.5556 21.915 25.8764 22.6038 23.8958 22.6038C23.0993 22.6038 22.3351 22.4639 21.6031 22.184C20.8712 21.9042 20.2146 21.5059 19.6333 20.9893L17.4375 18.9872L19.375 17.2434L21.3771 19.0518C21.7215 19.3531 22.109 19.59 22.5396 19.7622C22.9701 19.9344 23.4222 20.0205 23.8958 20.0205C25.1444 20.0205 26.2101 19.5792 27.0927 18.6965C27.9753 17.8139 28.4167 16.7483 28.4167 15.4997C28.4167 14.2511 27.9753 13.1854 27.0927 12.3028C26.2101 11.4202 25.1444 10.9788 23.8958 10.9788C23.4222 10.9788 22.9701 11.065 22.5396 11.2372C22.109 11.4094 21.7215 11.6462 21.3771 11.9476L11.3667 20.9893C10.7854 21.5059 10.1288 21.9042 9.39687 22.184C8.66493 22.4639 7.90069 22.6038 7.10417 22.6038Z"
        fill="white"
      />
    </g>
  </svg>
);

export default Infinity;
